import { type Dispatch, type SetStateAction } from "react";
import type { IdeaChannel } from "../protocol";

/** The ideas kanban: draft / ready / in_progress / done columns with drag-to-restatus + search. */
export function IdeaBoard({
  channels,
  ideaQuery,
  setIdeaQuery,
  dragCol,
  setDragCol,
  onOpenIdea,
  onDropCard,
}: {
  channels: IdeaChannel[];
  ideaQuery: string;
  setIdeaQuery: (q: string) => void;
  dragCol: string | null;
  setDragCol: Dispatch<SetStateAction<string | null>>;
  onOpenIdea: (id: string) => void;
  onDropCard: (id: string, col: string) => void;
}) {
  return (
    <div className="kanban-wrap">
      {channels.length > 0 && (
        <div className="sidebar-search">
          <input
            value={ideaQuery}
            onChange={(e) => setIdeaQuery(e.target.value)}
            placeholder="Search ideas…"
          />
        </div>
      )}
      {channels.length === 0 ? (
        <p className="muted" style={{ padding: 16 }}>
          No ideas yet.
        </p>
      ) : (
        <div className="kanban">
          {(["draft", "ready", "in_progress", "done"] as const).map((col) => {
            const q = ideaQuery.trim().toLowerCase();
            const cards = channels.filter((c) => {
              const inCol = col === "done" ? c.status === "done" || c.status === "rejected" : c.status === col;
              const match =
                !q ||
                c.title.toLowerCase().includes(q) ||
                c.description.toLowerCase().includes(q) ||
                c.doc.toLowerCase().includes(q);
              return inCol && match;
            });
            return (
              <div
                key={col}
                className={`kanban-col${dragCol === col ? " drag-over" : ""}`}
                onDragOver={(e) => {
                  e.preventDefault();
                  if (dragCol !== col) setDragCol(col);
                }}
                onDragLeave={() => setDragCol((d) => (d === col ? null : d))}
                onDrop={(e) => {
                  setDragCol(null);
                  const id = e.dataTransfer.getData("text/plain");
                  if (id) onDropCard(id, col);
                }}
              >
                <div className="kanban-col-head">
                  {col.replace("_", " ")}
                  <span className="kanban-count">{cards.length}</span>
                </div>
                <div className="kanban-cards">
                  {cards.map((c) => (
                    <div
                      key={c.id}
                      className="kanban-card"
                      draggable
                      onDragStart={(e) => e.dataTransfer.setData("text/plain", c.id)}
                      onClick={() => onOpenIdea(c.id)}
                    >
                      <div className="kanban-card-title">{c.title || "(untitled)"}</div>
                      {c.description && <div className="kanban-card-desc">{c.description}</div>}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
